<template>
    <v-container v-if="!quizFinished">
        <v-row :style="styleBackground">
            <v-col cols="12">
                <v-row>
                    <v-col class="text-center mb-4 cor-branca">
                        <section class="score">
                            <h2>{{ playerName }} {{ win_count }} x {{ lose_count }} </h2>
                        </section>
                        <v-progress-linear
                            :value="progress"
                            height="30"
                            color="green"
                            class="my-1">
                            {{ Math.round(progress) }}%
                        </v-progress-linear>
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="12" v-if="!quizFinished && question">
                <v-row>
                    <v-col class="text-center mb-4 cor-branca">
                        <v-row>
                            <!-- Exibe a imagem da pergunta, se existir -->
                            <v-col>
                                <img v-if="questionImageUrl" :src="questionImageUrl" alt="Imagem da pergunta" @error="onImageError" style="max-width: 80%; margin-bottom: 16px;" /></v-col>

                        </v-row>
                        <h2>{{ question }}</h2>
                        <v-form ref="form">
                          <v-radio-group
                                    v-model="chosen_answer"
                                    inline
                                    class="d-flex justify-center align-center"
                                    :disabled="answerSubmitted">
                                    <v-radio
                                        v-for="(answer, index) in answers"
                                        :key="index"
                                        color="green"
                                        class="d-flex align-center radio-option"
                                        :value="answer.value">
                                        <template #label>                                            
                                            <span style="line-height: 3;">
                                                {{ answer.label ? answer.label.trim() : '' }}
                                            </span>
                                        </template>
                                    </v-radio>
                                </v-radio-group>

               

                            <v-btn
                                :disabled="!chosen_answer || answerSubmitted"
                                @click="submitAnswer"
                                color="success"
                                class="mt-4">
                                Confirmar
                            </v-btn>
                        </v-form>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-container>

    <!-- Painel de resultado final -->
    <v-container :style="styleBackground" v-else>
        <v-row class="text-center cor-branca">
            <v-col cols="12">
                <h1>🎉 Parabéns, você completou o quiz!</h1>
                <h3>
                    Seu placar final foi: {{ playerName }} {{ win_count }} x {{ lose_count }}
                </h3>
            </v-col>
            <v-col cols="12">
                <v-table density="compact" class="zebra-table">
                    <thead class="left-align-small-font">
                        <tr>
                            <th>ID</th>
                            <th>Pergunta</th>
                            <th>Resposta</th>
                            <th>Correta</th>
                            <th>Resultado</th>
                        </tr>
                    </thead>
                    <tbody class="left-align-small-font">
                        <tr v-for="(resp, index) in responses" :key="index">
                            <td>{{ resp.questionId }}</td>
                            <td>{{ resp.question }}</td>
                            <td>{{ resp.chosen }}</td>
                            <td>{{ resp.correct }}</td>
                            <td>{{ resp.result }}</td>
                        </tr>
                    </tbody>
                </v-table>
            </v-col>
            <v-col cols="12" class="mt-4">
                <v-btn
                    @click="saveAnswers"
                    color="primary"
                    :disabled="savingAnswers">
                    Salvar Respostas
                </v-btn>
            </v-col>
        </v-row>
    </v-container>

    <!-- Modal de Erro/Sucesso -->
    <ModalMessage
        :dialog="showModal"
        @update:dialog="showModal = $event"
        :title="modalTitle"
        :message="modalMessage"
        :type="modalType" />
</template>

<script>
import ModalMessage from "./ModalMessage.vue";
import {
    loadPrivateKey,
    fetchQuestions,
    saveAnswers
} from "../services/googleSheetsSevice";

export default {
    components: {
        ModalMessage
    },
    props: ["playerName", "categoryName", "sessionKey"],
    data() {
        return {
            savingAnswers: false,
            backgroundImage: "/img/back/1.jpg",
            currentQuestion: {},
            question: "",
            answers: [],
            chosen_answer: null,
            questions: [],
            questionsAnswered: [],
            responses: [],
            win_count: 0,
            lose_count: 0,
            quizFinished: false,
            answerSubmitted: false,
            // Modal
            showModal: false,
            modalTitle: "",
            modalMessage: "",
            modalType: "success",
        };
    },
    computed: {
        progress() {
            return (this.questionsAnswered.length / this.questions.length) * 100;
        },
        styleBackground() {
            return {
                background: `url(${this.backgroundImage})`,
                backgroundSize: "cover",
                minHeight: "100vh",
            };
        },
        // Computed para construir a URL da imagem da pergunta
        questionImageUrl() {
            if (!this.categoryName || !this.currentQuestion || !this.currentQuestion.id) {
                return "";
            }
            // Converte espaços em underscores (ex.: "QUIZ 2" -> "QUIZ_2")
            const groupName = this.categoryName.replace(/ /g, "_");
            // Formata o id da pergunta com dois dígitos
            console.log('QUESTÃO',this.currentQuestion.id);
            const paddedId = String(this.currentQuestion.id-1).padStart(2, "0");
            // Constrói o caminho da imagem (assumindo que as imagens estão em public/img/perg/)
            const img = `/img/perg/${groupName}_${paddedId}.jpeg`;
            console.log('link img:' + img);
            return img;
        }
    },
    methods: {
        onImageError(event) {
            event.target.style.display = "none";
        },
        showAlertModalAsync(title, message, type = "success") {
            return new Promise((resolve) => {
                this.showModal = true;
                this.modalTitle = title;
                this.modalMessage = message;
                this.modalType = type;
                this.$watch("showModal", (newValue) => {
                    if (!newValue) {
                        resolve();
                    }
                });
            });
        },
        async loadQuizQuestions() {
            try {
                this.questions = await fetchQuestions(this.categoryName);
                this.getNewQuestion();
            } catch (error) {
                console.error("Erro ao buscar perguntas:", error);
            }
        },
        getNewQuestion() {
            const nextQuestion = this.questions.find(
                (q) => !this.questionsAnswered.includes(q.question)
            );
            if (nextQuestion) {
                this.currentQuestion = nextQuestion;
                this.question = nextQuestion.question;
                this.correctAnswer = nextQuestion.correctAnswer.trim();
                this.answers = nextQuestion.options.map((opt, index) => ({
                    label: `${String.fromCharCode(65 + index)} - ${opt.trim()}`,
                    value: opt.trim(),
                }));
                this.chosen_answer = null;
            } else {
                this.quizFinished = true;
            }
        },
        submitAnswer() {
            if (!this.$refs.form.validate()) {
                return;
            }
            this.answerSubmitted = true;
            const isCorrect = this.chosen_answer === this.correctAnswer;
            if (isCorrect) {
                this.win_count++;
            } else {
                this.lose_count++;
            }
            console.log('PERGUNTA ATUAL:',this.currentQuestion);
            this.responses.push({
                questionId: this.currentQuestion.id,
                question: this.currentQuestion.question,
                chosen: this.chosen_answer,
                correct: this.correctAnswer,
                result: isCorrect ? "CORRETA" : "INCORRETA",
            });
            this.questionsAnswered.push(this.question);
            setTimeout(() => {
                this.answerSubmitted = false;
                this.getNewQuestion();
            }, 1000);
        },
        async saveAnswers() {
            this.savingAnswers = true;
            try {
                await saveAnswers(this.playerName, this.categoryName, this.sessionKey, this.responses);
                await this.showAlertModalAsync("Sucesso", "Você gravou suas respostas com sucesso!", "success");
                window.location.reload();
            } catch (error) {
                this.showAlertModal("Erro", "Ocorreu um erro ao salvar suas respostas.", "error");
                console.error("Erro ao salvar respostas:", error);
            } finally {
                this.savingAnswers = false;
            }
        }
    },
    async created() {
        await loadPrivateKey();
        await this.loadQuizQuestions();
    }
};
</script>

<style scoped>
.cor-branca {
    background-color: rgba(255, 255, 255, 0.8);
    text-align: center;
}

.zebra-table tbody tr:nth-child(odd) {
    background-color: #f2f2f2;
}

.left-align-small-font {
    text-align: left;
    font-size: 12px;
}

::v-deep .v-radio .v-label {
    display: block !important;
    text-align: left !important;
    justify-content: flex-start !important;
}
</style>
